import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from 'app-components/flux/core/actionHelpers';
import type { BaseResource } from 'app-components/flux/core/resourceStoreTypes';

export type NPSSurveyResult = BaseResource & {
  surveyResult: 'ABANDONED' | 'CANCELLED' | 'COMPLETED';
};

const npsSurveyResultPayloadCreator = getPayloadCreator<NPSSurveyResult, NPSSurveyResult>();
const npsSurveyFailurePayloadCreator = getFailurePayloadCreator<unknown, Meta<NPSSurveyResult>>();

export const checkIfNPSSurveyRequestedAction = createAction('CHECK_IF_NPS_REQUESTED');
export const postNPSSurveyResultAction = createAction('POST_NPS_RESULT', npsSurveyResultPayloadCreator);
export const postNPSSurveyResultSuccessAction = createAction('POST_NPS_RESULT_SUCCESS', npsSurveyResultPayloadCreator);
export const postNPSSurveyResultFailureAction = createAction('POST_NPS_RESULT_FAILURE', npsSurveyFailurePayloadCreator);
